var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpaceInsights = function SvgSpaceInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "4 7 40 34"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 32,
    x: 5,
    y: 8,
    fill: "#FBFAFA",
    rx: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D2D2D2",
    strokeDasharray: "2 3.4",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M11 17h26M11 24h26M11 31h26",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F59E0B",
    d: "M5 25v8a7 7 0 0 0 7 7h10Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 32,
    x: 5,
    y: 8,
    stroke: "rgba(10,10,10,0.12)",
    strokeWidth: 1.5,
    rx: 7
  })));
};
export default SvgSpaceInsights;